// Components
import TableOfContents from '../../../../components/news/TableOfContents';

TableOfContents.init();
